import { inject, watch, ref } from 'vue';
/**
 * Composable to trigger analytics refresh after 60 seconds
 * Works WITH the existing watchEffect in components
 * 
 * @param {Function} fetchFunction - The function to call when refresh is triggered
 * @param {Array} dependencies - Array of computed/ref values that must be valid before fetching
 */
export function useAnalyticsRefresh(fetchFunction, dependencies = []) {
  const refreshKey = inject('analyticsRefreshKey', ref(0));
  
  watch(refreshKey, (newVal, oldVal) => {
    if (newVal > 0 && newVal !== oldVal) {
      const allDependenciesMet = dependencies.length === 0 || 
        dependencies.every(dep => {
          const value = dep?.value !== undefined ? dep.value : dep;
          return value !== null && value !== undefined;
        });
      
      if (allDependenciesMet) {
        fetchFunction();
      } else {
        console.log('⏸️ Auto-refresh skipped - dependencies not ready');
      }
    }
  });
}
